module.exports = __webpack_public_path__ + "img/spcial-parts-icon.fceec8a4.png";